import { AutocompleteAPI, FieldAPI, FormAPI, InputAPI, TextAreaAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeCancel, OnBeforeSubmit, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { FragmentNames, ReservedBloodProductsReverseAliases } from '../../../../../codegen';
import BaseController from '../../../../BaseController';
import InformationBarUtils from '../../../../commons/header/information-bar-header-utils';
import { ReasonType } from '../../adult-tpn/adult-tpn-types';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import MedicationService from '../../../services/medication-service';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { Endpoint } from '../../../../../constants/endpoints';
import { Inject } from '@odinjs/odin';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import moment from 'moment';
import { ISO_FULL_DATE_FORMAT } from '../../../../../constants/date-utils';
import { ReservedProduction } from '../../blood-management/blood-management-types';
import { ApplicationRoute } from '../../../../../constants/routes';
import { AdminModalsService } from '../../../services/admin-modals-service';

@Controller({ component: ReservedBloodProductsReverseAliases.RESERVED_BLOOD_PRODUCTS_REVERSE_LAYOUT, fragment: FragmentNames.RESERVED_BLOOD_PRODUCTS_REVERSE})
export default class ReversedBloodProductsReverseController extends BaseController {

  @Inject(ReservedBloodProductsReverseAliases.REVERSE_FORM)
  private formApi!: FormAPI;

  @Inject(ReservedBloodProductsReverseAliases.REASON_AUTOCOMPLETE)
  private reasonAutocompleteApi!: AutocompleteAPI;

  @Inject(ReservedBloodProductsReverseAliases.NOTES_TEXT_AREA)
  private notesTextAreaApi!: TextAreaAPI;

  @Inject(ReservedBloodProductsReverseAliases.TITLE_FIELD)
  private titleFieldApi!: FieldAPI;

  @Inject(ReservedBloodProductsReverseAliases.SCHEDULE_DATE_INPUT)
  private scheduleDateInputApi!: InputAPI;

  @OnMount(ReservedBloodProductsReverseAliases.RESERVED_BLOOD_PRODUCTS_REVERSE_LAYOUT)
  handleMountLayout(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    this.context.set({ encounterId, patientId });
    const reservedProduct = this.context.getBulkData() as unknown as ReservedProduction;
    this.context.set({reservedProduct: { ...reservedProduct }})
    this.titleFieldApi.setData({ materialDescription: reservedProduct.description });
    this.scheduleDateInputApi.setValue(reservedProduct.reservationDate);
    this.scheduleDateInputApi.setReadOnly(true);
    InformationBarUtils.collapsedBar = true;
  }

  @OnMount(ReservedBloodProductsReverseAliases.DATE_INPUT)
  handleDateFieldMount(event: MountEvent): void {
    const api = event.target as InputAPI;
    const currentTimeMoment = moment();
    this.context.set({ currentTime: currentTimeMoment.format(ISO_FULL_DATE_FORMAT) });
    api.setValue(currentTimeMoment.utc().format(ISO_FULL_DATE_FORMAT));
  }

  @OnBeforeCancel(ReservedBloodProductsReverseAliases.REVERSE_FORM)
  handleCancelForm(): void {
    applicationContext.popNavigationItem();
  }

  @OnBeforeSubmit(ReservedBloodProductsReverseAliases.REVERSE_FORM)
  handleSubmitForm(): void {
    this.reverse();
  }

  private reverse(): void {
    const reasonSelected = this.reasonAutocompleteApi.getValue() as unknown as ReasonType;
    const {
      encounterId,
      sequenceNumber
    } = this.historyService.getCurrentRouteParams();
    const situationSolutionType = 3
    const reservedProduct = this.context.get('reservedProduct');

    const body = {
      dateHour: moment().format(ISO_FULL_DATE_FORMAT),
      encounterNumber: Number(encounterId),
      justificationDescription: this.notesTextAreaApi.getValue(),
      prescriptionNumber: Number(reservedProduct.prescriptionNumber),
      reasonSequenceNumber: reasonSelected.sequenceNumber,
      reserveNumber: reservedProduct.reservationId,
      reserveProductSequenceNumber: reservedProduct.id,
      situationSolutionType,
      solutionNumber: sequenceNumber
    } as Record<string, Value>;

    HttpService.post(Endpoint.REVERSE_LAST_EVENT, {}, { body })
      .then(() => {
        MedicationService.showToast(MessageService.translate('text.revert-event'), ToastLevel.SUCCESS)
        this.redirectToTimeline();
      })
      .catch((error) => {
        const message = error.body.messageDescription;
        const errorMessage = error.body.errors.join('; ')
        MedicationService.showToast(message ?? errorMessage, ToastLevel.ERROR)
      }).finally(() => {
        this.formApi.setLocked(true);
      });
  }
  private redirectToTimeline(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const redirectRoute = ApplicationRoute.ADEP_ELETRONIC_SERVICE_PERSONAL_INFORMATION;
    applicationContext.redirect(redirectRoute, { encounterId, patientId });
    applicationContext.clearNavigationStack();
    AdminModalsService.redirectToTimeline(FragmentNames.RESERVED_BLOOD_PRODUCTS_REVERSE);
    AdminModalsService.redirectToTimeline(FragmentNames.RESERVED_BLOOD_PRODUCTS_VIEWER);
  }
}
